<button
  class="lum-button lum-button--square lum-button--small lum-button--link"
  [matTooltip]="'Update ' + orderTooltip"
  [disabled]="params.data.status === orderStatus.COMPLETED"
  (click)="onUpdateOrderEvent()"
>
  <mat-icon color="primary">edit</mat-icon>
</button>
<button
  *ngIf="'red_DV-3138_template_management' | featureFlag"
  class="lum-button lum-button--square lum-button--small lum-button--link"
  [matTooltip]="'Export ' + orderTooltip"
  (click)="onExportOrderEvent(); $event.stopPropagation()"
>
  <mat-icon color="accent">get_app</mat-icon>
</button>
<button
  class="lum-button lum-button--square lum-button--small lum-button--link"
  [disabled]="params.data.status === orderStatus.COMPLETED"
  [matTooltip]="'Delete ' + orderTooltip"
  (click)="onDeleteOrderEvent(); $event.stopPropagation()"
>
  <mat-icon color="warn">delete</mat-icon>
</button>
